import { ScreenBase } from "@frui.ts/screens/dist";
import { interfaces } from "inversify";
import GDPRViewModel from "../../../common/gdpr/GDPRViewModel";
import { attachAutomaticBlurValidator } from "../../../../utils/validationPatch";
import LocalizationService from "../../../../services/localizationService";
import { bound } from "@frui.ts/helpers";
import InputEmail, { EmailConfirmationValidationRules, EmailValidationRules } from "entities/InputEmail";
export default class EmailInputViewModel extends ScreenBase {
  gdprViewModel: GDPRViewModel;

  constructor(
    public inputEmail: InputEmail,
    public emailUsageInfo: string,
    private GDPR: string,
    private localizationService: LocalizationService,
    private gdprVMFactory: ReturnType<typeof GDPRViewModel.Factory>
  ) {
    super();
    attachAutomaticBlurValidator(this.inputEmail, {
      ...EmailValidationRules,
      ...EmailConfirmationValidationRules,
    });
  }

  @bound
  translate(attribute: string, again = false) {
    return this.localizationService.translateAttribute(again ? "contact.again" : "contact", attribute);
  }

  @bound
  translateConfirmation(attribute: string) {
    return this.translate(attribute, true);
  }

  static Factory({ container }: interfaces.Context) {
    return (inputEmail: InputEmail, emailUsageInfo: string, GDPR: string) => {
      return new EmailInputViewModel(
        inputEmail,
        emailUsageInfo,
        GDPR,
        container.get(LocalizationService),
        container.get(GDPRViewModel.Factory)
      );
    };
  }
}
